(function () {
	angular
		.module('trackeye')
		.factory('AccountService', AccountService);

	AccountService.$inject = ["Account", "C4ApiService", "$q"];

	function AccountService(Account, api, $q) {
		var exports = {},
			account = new Account();

		/**
		 *
		 * @returns {Promise}
		 */
		exports.fetch = function (ignore_auth) {
			var defer = $q.defer();

			if (account && account.isInitialized()) {
				defer.resolve(account);
			} else {
				api.getAccount(ignore_auth).then(function (resp) {
					account.populate(resp.data);
					defer.resolve(account);
				}, defer.reject);
			}

			return defer.promise;
		};

		exports.get = function () {
			return account;
		};

		exports.create = function (data) {
			return api.create_account({
				"email": data.email,
				"username": data.username,
				"name": data.name,
				"password": data.password,
				"number": data.device_number,
				"code": data.device_code
			});
		};

		exports.flush = function () {
			account = new Account();
		};

		exports.updateAccountTerms = function(terms, accepted) {
			return api.accountTerms({
				type: terms.type,
				customer_id: terms.customer_id,
				accepted: accepted,
				username: terms.username
			});
		};

		return exports;
	}
})();